module.exports = __webpack_public_path__ + "img/ka4-2.5e64fcf8.png";